import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { MemberAddSwitchBtn } from "./MemberAddSwitchBtn";
import { Button, Modal, FormControl, Radio } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";
import { customLog, emailRegex } from "../../variables/Variables";
import ReactTooltip from "react-tooltip";
import { usePapaParse, useCSVReader, formatFileSize } from "react-papaparse";

import {
  inviteNewMembers,
  getPlanofSuperAdmin,
  getNumOfUsers,
} from "./MemberManagementHelper";
import { FadeLoader } from "react-spinners";

import { fire, auth } from "../../firebase/index";

import LocalizedStrings from "react-localization";
import DetailsButton from "./DetailsButton";
import { update } from "lodash";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    addMemberButtonTitle: "Add Member",
    addMemberTitle: "Add Member",
    usedUpTitle: "You have used up",
    memberLimitTitle: " of member limit",
    emailAlert: "Please insert a valid email address and name",
    emailPlaceholder: "Key in your email address and press enter",
    memberNameLabel: "Member Name",
    memberEmailLabel: "Member Email",
    isAdminLabel: "Is Admin",
    submitButton: "Submit",
    closeButton: "Close",
    removeSelectedBtn: "Remove Selected",
    noDataTitle: "There is no data to display",
    loadingMessage1:
      "It will take a few minutes to add the members into the group.",
    loadingMessage2pt1: "Please ",
    loadingMessage2pt2: "Do Not ",
    loadingMessage2pt3: "refresh the page.",
    loadingMessage3: "The screen will refresh when done.",
    addMemberError: "Unable to add the members, Please try again",
    errorMessageTitle:
      "Please delete some members as you have exceeded plan limits",
    maxLimit: "You have reached the max limit of users",
    usernameTip:
      "A member is a registered user to your subscription account. A member can be assigned an admin role or a user role",
    usernameTip2:
      "An admin is a member assigned admin role by the super admin. Admin is able to add, remove, manage locks, select recipients, view, edit & manage access.",
    addLabel: "Add",
    importLabel: "Import",
    emailPlaceholder: "Email",
    namePlaceholder: "Member Name",
    CSVTemplateLabel: "CSV Template: ",
    CSVTemplateLink: "Download CSV",
    errorMessage1:
      "Cannot find appropriate fields. Please use correct CSV template.",
    errorMessage2:
      "Member limit exceeded. Please remove some members or upgrade your plan.",
    errorMessage3: "Please remove duplicate emails: ",
    duplicateEmailAlert: "Email has already been added.",
    limitReachedAlert:
      "Member limit exceeded. Please remove some members or upgrade your plan.",
    membersRemoved: "Selected members removed",
    addMemberSuccess: "added",
    errorMessageTitle:
      "Please delete some members as you have exceeded plan limits",
    maxLimit: "You have reached the max limit of users",
  },
  ja: {
    addMemberButtonTitle: "メンバーを追加",
    addMemberTitle: "メンバーを追加",
    usedUpTitle: "メンバー制限の",
    memberLimitTitle: "を使用しました",
    emailAlert: "有効なメールアドレスを入力してください",
    emailPlaceholder: "メールにキーを入力してEnterキーを押します",
    memberNameLabel: "名前",
    memberEmailLabel: "メンバーEメール",
    isAdminLabel: "管理者権限",
    submitButton: "OK",
    closeButton: "閉じる",
    removeSelectedBtn: "削除",
    noDataTitle: "表示するデータがありません。",
    loadingMessage1: "完了まで数分かかることがあります。",
    loadingMessage1: "完了まで数分かかることがあります。",
    loadingMessage2pt1: "",
    loadingMessage2pt2:
      "完了メッセージがでるまでこの画面をリフレッシュしないでください。",
    loadingMessage2pt3: "",
    loadingMessage3: "完了すると画面が更新されます。",
    addMemberError:
      "メンバーの追加ができませんでした。ご契約パッケージの最大数を超えていないか確認後、再度入力して下さい。",
    errorMessageTitle:
      "このご契約プランのメンバー登録数には制限があります。超過数を削除してください。",
    maxLimit: "ご契約パッケージの最大数を超えています。",
    usernameTip:
      "メンバーは、あなたのサブスクリプションアカウントに登録されたユーザーです。メンバーには管理者役割またはユーザー役割が割り当てられる場合があります。",
    usernameTip2:
      "管理者は、スーパ管理者によって管理者役割を割り当てられたメンバーです。管理者は、ロックの追加、削除、管理、受取人の選択、アクセスの表示、編集、管理ができます。",
    addLabel: "追加",
    importLabel: "インポート",
    emailPlaceholder: "メール",
    namePlaceholder: "名前",
    CSVTemplateLabel: "CSVテンプレート: ",
    CSVTemplateLink: "CSVをダウンロード",
    errorMessage1:
      "適切なフィールドが見つかりません。正しいCSVテンプレートを使用してください。",
    errorMessage2:
      "メンバーの制限を超えました。メンバーを削除するか、プランをアップグレードしてください。",
    errorMessage3: "重複したメールアドレスを削除してください: ",
    duplicateEmailAlert: "メールアドレスはすでに追加されています。",
    limitReachedAlert:
      "メンバーの制限を超えました。メンバーを削除するか、プランをアップグレードしてください。",
    membersRemoved: "選択したメンバーが削除されました。",
    addMemberSuccess: "added",
    errorMessageTitle:
      "Please delete some members as you have exceeded plan limits",
    maxLimit: "You have reached the max limit of users",
  },
  es: {
    addMemberButtonTitle: "Agregar Miembro",
    addMemberTitle: "Agregar Miembro",
    usedUpTitle: "Has utilizado",
    memberLimitTitle: " del límite de miembros",
    emailAlert:
      "Por favor, inserta una dirección de correo electrónico y un nombre válidos",
    emailPlaceholder:
      "Ingresa tu dirección de correo electrónico y presiona enter",
    memberNameLabel: "Nombre",
    memberEmailLabel: "Correo Electrónico del Miembro",
    isAdminLabel: "Es Admin",
    submitButton: "Enviar",
    closeButton: "Cerrar",
    removeSelectedBtn: "Eliminar Seleccionados",
    noDataTitle: "No hay datos para mostrar",
    loadingMessage1: "Tomará unos minutos agregar los miembros al grupo.",
    loadingMessage2pt1: "Por favor, ",
    loadingMessage2pt2: "No ",
    loadingMessage2pt3: "recargues la página.",
    loadingMessage3: "La pantalla se actualizará cuando se complete.",
    addMemberError:
      "No se pudieron agregar los miembros, por favor intenta de nuevo",
    errorMessageTitle:
      "Por favor, elimina algunos miembros ya que has superado los límites del plan",
    maxLimit: "Has alcanzado el límite máximo de usuarios",
    usernameTip:
      "Un miembro es un usuario registrado en tu cuenta de suscripción. Un miembro puede tener un rol de administrador o de usuario.",
    usernameTip2:
      "Un administrador es un miembro asignado con el rol de administrador por el super administrador. El administrador puede agregar, eliminar, gestionar candados, seleccionar destinatarios, ver, editar y gestionar accesos.",
    addLabel: "Agregar",
    importLabel: "Importar",
    emailPlaceholder: "Correo electrónico",
    namePlaceholder: "Nombre",
    CSVTemplateLabel: "Plantilla CSV: ",
    CSVTemplateLink: "Descargar CSV",
    errorMessage1:
      "No se pueden encontrar los campos adecuados. Utilice la plantilla CSV correcta.",
    errorMessage2:
      "Se ha excedido el límite de miembros. Elimine algunos miembros o actualice su plan.",
    errorMessage3: "Por favor, elimine los correos electrónicos duplicados: ",
    duplicateEmailAlert: "El correo electrónico ya ha sido agregado.",
    limitReachedAlert:
      "Se ha excedido el límite de miembros. Elimine algunos miembros o actualice su plan.",
    membersRemoved: "Miembros seleccionados eliminados",
  },
});

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

export class InviteMember extends Component {
  constructor(props) {
    super(props);

    this.handleShow = this.handleShow.bind(this);
    this.renderBtn = this.renderBtn.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.updateData = this.updateData.bind(this);
    this.onAfterDeleteRow = this.onAfterDeleteRow.bind(this);
    this.customConfirmDialog = this.customConfirmDialog.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.promptNotification = this.promptNotification.bind(this);
    this.eraseAll = this.eraseAll.bind(this);
    this.handlestring = this.handlestring.bind(this);
    this.handlenoname = this.handlenoname.bind(this);
    this.handleemailformat = this.handleemailformat.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleReload = this.handleReload.bind(this);
    this.state = {
      memberList: [],
      selectedMembers: [],
      duplicateList: [],
      showPopup: false,
      invalidEmail: false,
      invalidHeaders: false,
      tooManyMems: false,
      duplicates: false,
      isInvalid: true,
      isInvalidClose: false,
      loading: false,
      _notificationSystem: null,
      maxUsers: "",
      currNumOfUsers: 0,
      isDisabled: false,
      csvdata: {},
      radiocheck: true,
      name: "",
      email: "",
      duplicateEmail: false,
      limitReached: false,
    };
  }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillMount() {
    getPlanofSuperAdmin((res) => {
      // customLog(res);
      this.setState({
        maxUsers: res.maxUsers,
        currNumOfUsers: res.currNumOfUsers,
      });

      customLog(res.currNumOfUsers);
      customLog(res.maxUsers);

      if (
        res.currNumOfUsers > res.maxUsers ||
        res.currNumOfUsers === res.maxUsers
      ) {
        customLog("User has more or equals to the max users");
        this.setState({
          isDisabled: true,
        });
      } else {
        customLog("User is within the max user limit");
        this.setState({
          isDisabled: false,
        });
      }
    });

    //! Language Setting
    if (auth.currentUser !== null) {
      const db = fire.database();

      db.ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });

      db.ref("groupAccounts")
        .once("value")
        .then((snapshot) => {
          if (snapshot.exists()) {
            snapshot.forEach((superAdmin) => {
              const superAdminData = superAdmin.val();
              // customLog(superAdminData.members);
              const memberDetails = superAdminData.members;

              for (let eachMemberId in memberDetails) {
                // customLog(memberDetails[eachMember]);
                const eachMemberDetails = memberDetails[eachMemberId];
                // customLog(eachMemberDetails.memberEmail);
                const eachMemberEmail = eachMemberDetails.memberEmail;
                // customLog(eachMemberDetails);

                // if (eachMemberEmail === auth.currentUser.email) {
                if (eachMemberEmail === auth.currentUser.email) {
                  const superAdminID = superAdmin.key;

                  db.ref("groupAccounts/")
                    .child(superAdminID)
                    .child("members")
                    .once("value")
                    .then((memberSnap) => {
                      const numOfMembers = memberSnap.numChildren();

                      db.ref("groupAccounts/" + superAdminID)
                        .once("value")
                        .then((snapshot) => {
                          const snapshotVal = snapshot.val();

                          const payment = snapshotVal.payment;
                          const maxUserLimit = payment.maxUsers;

                          if (numOfMembers > maxUserLimit) {
                            this.promptNotification(
                              localizationStrings.errorMessageTitle,
                              "error",
                              "tc",
                              0,
                              ""
                            );
                          }
                        });
                    });
                }
              }
            });
          }
        });
    }
  }

  createCustomDeleteButton = (onBtnClick) => {
    return (
      <Button bsSize="large" id="invitememberDeleteBtn" onClick={onBtnClick}>
        {localizationStrings.removeSelectedBtn}
      </Button>
    );
  };

  eraseAll() {
    window.location.reload(false);
  }

  async onSubmit() {
    this.setState({
      loading: true,
      isInvalid: true,
      isInvalidClose: false,
    });
    const { dataCallBack } = this.props;
    customLog("CHECK : submit btn clicked !");
    await inviteNewMembers(this.state.memberList, (res) => {
      customLog("res.status " + res.status);
      if (res.status === true) {
        dataCallBack(res);

        const existingMembers = res.existingMembers;
        const existingMembersInOther = res.existingMembersInOther;
        const addedMembers = res.addedMembers;
        const noOfExisting = existingMembers.length;

        for (let i = 0; i < existingMembers.length; i++) {
          this.promptNotification(
            `${existingMembers[i]} already exists. Cannot add again.`,
            "warning",
            "tc",
            10
          );
        }
        for (let i = 0; i < existingMembersInOther.length; i++) {
          this.promptNotification(
            `${existingMembersInOther[i]} exists in another group. Cannot add here.`,
            "warning",
            "tc",
            10
          );
        }
        for (let i = 0; i < addedMembers.length; i++) {
          this.promptNotification(
            `${addedMembers[i]} ${localizationStrings.addMemberSuccess}`,
            "success",
            "tc",
            10
          );
        }

        this.setState({
          loading: false,
          showPopup: false,
          memberList: [],
          isDisabled: false,
          currNumOfUsers: this.state.currNumOfUsers - noOfExisting,
          name: "",
          email: "",
        });
      } else {
        this.promptNotification(
          localizationStrings.addMemberError,
          "error",
          "tc",
          5
        );

        this.setState({
          loading: false,
          showPopup: false,
          isDisabled: false,
          memberList: [],
          name: "",
          email: "",
        });
      }
    });
  }

  customConfirmDialog(next) {
    next();
  }

  onAfterDeleteRow(emailDeleted) {
    // customLog(emailDeleted); //this is the email of the deleted user
    let numOfDeletedUsers = 0;
    emailDeleted.forEach((deletedUser) => {
      numOfDeletedUsers++;
      const idx = this.state.memberList.findIndex(
        (member) => member.memberEmail === deletedUser
      );

      let updateCurrUsers = this.state.currNumOfUsers - numOfDeletedUsers;
      let currMemberListState = this.state.memberList;

      // if (updateCurrUsers !== 4) {
      //   this.setState({ isDisabled: false });
      // }
      currMemberListState.splice(idx, 1);

      this.setState({
        memberList: currMemberListState,
        currNumOfUsers: updateCurrUsers,
      });

      if (updateCurrUsers < this.state.maxUsers) {
        customLog(updateCurrUsers);
        customLog(this.state.maxUsers);
        this.setState({
          isDisabled: false,
        });
      }
    });
  }

  updateData(data) {
    // customLog("Toggle Btn update here ");
    const idx = this.state.memberList.findIndex(
      (member) => member.memberEmail === data.email
    );

    // this.state.memberList;

    // customLog(data);
    // customLog(idx);
    let member = Object.assign({}, this.state.memberList);
    member[idx].isAdmin = data.isAdmin;
    return this.setState({ member });
  }

  promptNotification(msg, lvl, position, duration, allowDismiss) {
    let allowDismissle = false;
    if (allowDismiss === "") {
      allowDismissle = true;
    }
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
      dismissible: allowDismissle,
    });
  }

  renderBtn(cell, row) {
    // customLog(row);
    return <MemberAddSwitchBtn data={row} dataCallBack={this.updateData} />;
  }

  handleShow() {
    getNumOfUsers((callback) => {
      this.setState({
        showPopup: true,
        currNumOfUsers: callback,
      });
    });
    // this.setState({
    //   showPopup: true
    // });
  }

  handleClose() {
    this.setState({
      showPopup: false,
      memberList: [],
      isDisabled: false,
      invalidHeaders: false,
      tooManyMems: false,
      duplicates: false,
      csvdata: {},
      isInvalid: true,
      invalidEmail: false,
      name: "",
      email: "",
      selectedMembers: [],
    });
  }
  handleReload() {
    this.setState({
      duplicateList: [],
      invalidEmail: false,
      invalidHeaders: false,
      tooManyMems: false,
      duplicates: false,
      isInvalidClose: false,
      name: "",
      email: "",
    });
    this.forceUpdate();
  }
  handlenoname(cell, row) {
    // console.log(row);
    if (cell) {
      row.noname = false;
      if (!row.noemail && !row.wrongformat) {
        row.noerrors = true;
        // console.log(this.state.memberList);
      } else {
        row.noerrors = false;
      }

      return cell;
    } else {
      row.noname = true;
      row.noerrors = false;

      return (
        <>
          <a data-tip data-for="nonametip">
            <span
              style={{
                color: "red",
                fontSize: "16px",
                marginLeft: "10px",
              }}
              className="glyphicon glyphicon-exclamation-sign"
              aria-hidden="true"
            ></span>
          </a>
          <ReactTooltip id="nonametip" effect="solid">
            <span>Please enter a username</span>
          </ReactTooltip>
        </>
      );
    }
  }
  handleemailformat(cell, row) {
    if (cell.trim() == "" || cell == null || cell == undefined) {
      row.noemail = true;
      row.wrongformat = true;
      row.noerrors = false;

      return (
        <>
          <a data-tip data-for="noemailtip">
            <span
              style={{
                color: "red",
                fontSize: "16px",
                marginLeft: "10px",
              }}
              className="glyphicon glyphicon-exclamation-sign"
              aria-hidden="true"
            ></span>
          </a>
          <ReactTooltip id="noemailtip" effect="solid">
            <span>Please enter an email</span>
          </ReactTooltip>
        </>
      );
    } else {
      row.noemail = false;
      if (emailRegex.test(cell)) {
        row.wrongformat = false;
        //check for dupes at all times
        //check memberlist for each email with the same email as this cell, increase counter for each
        let counter = 0;
        this.state.memberList.forEach((m) => {
          if (m.memberEmail.trim() == cell.trim()) {
            counter += 1;
          }
        });
        // console.log(cell);
        // console.log(counter);
        //if counter is 2(account for itself) or higher then display error
        if (counter > 1) {
          // console.log("dupe here");
          row.dupes = true;
          row.noerrors = false;

          return (
            <>
              <a data-tip data-for="dupeEmailtip">
                <span
                  style={{
                    color: "red",
                    fontSize: "16px",
                    marginLeft: "10px",
                    marginRight: "3px",
                  }}
                  className="glyphicon glyphicon-exclamation-sign"
                  aria-hidden="true"
                ></span>
              </a>
              <ReactTooltip id="dupeEmailtip" effect="solid">
                <span>Please remove duplicate email</span>
              </ReactTooltip>
              {cell.trim()}
            </>
          );
        } else {
          row.dupes = false;
          if (!row.noname) {
            row.noerrors = true;
          }

          return cell.trim();
        }
      } else {
        row.wrongformat = true;
        row.noerrors = false;

        return (
          <>
            <a data-tip data-for="emailformattip">
              <span
                style={{
                  color: "red",
                  fontSize: "16px",
                  marginLeft: "10px",
                  marginRight: "3px",
                }}
                className="glyphicon glyphicon-exclamation-sign"
                aria-hidden="true"
              ></span>
            </a>
            <ReactTooltip id="emailformattip" effect="solid">
              <span>Please follow email format: example@gmail.com</span>
            </ReactTooltip>
            {cell.trim()}
          </>
        );
      }
    }
  }
  // handleSubmit(){
  //   if(){

  //   }
  // }
  handlestring(CSVString) {
    //make extra item in each member stating error type like 1 for email format and so on
    //add ! to err cells if possible else for row
    //make hover for !
    //make sure ! appear on err
    const { readString } = usePapaParse();
    const prevMemberList = [...this.state.memberList];
    const prevNumofuser = this.state.currNumOfUsers;
    let maxusererror = false;
    let dupeerror = false;
    readString(CSVString, {
      worker: true,
      header: true,
      complete: (results) => {
        var dupelist = [];
        if (
          results.meta.fields.includes("Email") &&
          results.meta.fields.includes("Member-Name") &&
          results.meta.fields.includes("Admin-Rights") &&
          results.meta.fields.includes("No.")
        ) {
          var value = [];
          this.state.memberList.forEach((m) => {
            value.push(m.memberEmail);
          });
          //value only suppose to have email, not the object
          if (results.data.length > 1) {
            results.data.forEach((d) => {
              const email = d["Email"]
                ? d["Email"].trim().toLowerCase()
                : d["Email"];
              const name = d["Member-Name"]
                ? d["Member-Name"].trim()
                : d["Member-Name"];
              const adminRights = d["Admin-Rights"]
                ? d["Admin-Rights"].trim().toLowerCase()
                : d["Admin-Rights"];
              // .toString()
              // .toLowerCase()
              // .replace(/ +/g, "");
              //console.log(email);
              let nodupes = true;
              let counter = 0;
              value.forEach((c) => {
                if (c == email && email.trim() != "") {
                  nodupes = false;
                  // console.log(email + " has dupes");
                  dupeerror = true;
                  counter += 1;
                }
              });
              if (counter > 0) {
                dupelist.push("No." + d["No."] + " [" + email + "]");
                // console.log("adsfd a "+dupelist)
              }
              if (this.state.currNumOfUsers <= this.state.maxUsers) {
                // console.log("valid");
                value.push(email);
                const currentMemberList = this.state.memberList;
                let updatedCurrUsers = this.state.currNumOfUsers + 1;

                const idx = currentMemberList.findIndex(
                  (member) => member.email === email
                );
                customLog(idx);
                let errstatus =
                  emailRegex.test(email) && email.trim() !== "" && name !== "";
                const newMember = {
                  id: updatedCurrUsers,
                  memberName: name,
                  memberEmail: email,
                  isAdmin: adminRights == "yes" ? true : false,
                  noerrors: errstatus,
                  noname: name ? name === "" : true,
                  noemail: email ? email.trim() === "" : true,
                  wrongformat: !emailRegex.test(email),
                  dupes: false,
                };
                // console.log(newMember);
                if (idx < 0) {
                  //if not exist, idx = -1
                  currentMemberList.push(newMember);

                  this.setState({
                    memberList: currentMemberList,
                    currNumOfUsers: updatedCurrUsers,
                    isInvalid: false,
                    isInvalidClose: false,
                    invalidHeaders: false,
                    tooManyMems: false,
                    duplicates: false,
                  });
                  // console.log(this.state.memberList);
                }
              } else if (this.state.currNumOfUsers >= this.state.maxUsers) {
                // console.log("no space");
                maxusererror = true;
                //copy array before change
                //if too many then backup array with copy
                // this.setState({
                //   memberList: prevMemberList,
                //   currNumOfUsers: prevNumofuser
                // });
              } else {
                // console.log("invalid");
              }
            });
          } else {
            // console.log("empty fields");
          }
        } else {
          this.setState({
            invalidHeaders: true,
            tooManyMems: false,
            duplicates: false,
          });
        }

        // console.log(value);

        if (dupeerror) {
          this.setState({
            memberList: prevMemberList,
            duplicateList: dupelist,
            currNumOfUsers: prevNumofuser,
            duplicates: true,
            tooManyMems: false,
            invalidHeaders: false,
          });
        }
        if (maxusererror) {
          // console.log("limit reached");
          this.setState({
            memberList: prevMemberList,
            currNumOfUsers: prevNumofuser,
            tooManyMems: true,
            duplicates: false,
            invalidHeaders: false,
          });
        }
      },
    });
  }
  handleAdd(email, name) {
    this.setState({ duplicateEmail: false, limitReached: false });
    email = email.trim().toLowerCase();
    let emailValid = emailRegex.test(email) && email !== "";
    let namevalid = name !== "";
    // console.log(this.state.currNumOfUsers + " " + this.state.maxUsers);
    if (this.state.currNumOfUsers < this.state.maxUsers) {
      if (emailValid && namevalid) {
        const currentMemberList = this.state.memberList;

        let updatedCurrUsers = this.state.currNumOfUsers + 1;
        const idx = currentMemberList.findIndex(
          (member) => member.memberEmail === email
        );

        const newMember = {
          id: updatedCurrUsers,
          memberName: name,
          memberEmail: email,
          isAdmin: false,
          noerrors: true,
          noname: false,
          noemail: false,
          wrongformat: false,
          dupes: false,
        };
        // console.log(newMember);
        if (idx < 0) {
          currentMemberList.push(newMember);

          this.setState({
            memberList: currentMemberList,
            isInvalid: false,
            isInvalidClose: false,
            invalidEmail: false,
            currNumOfUsers: updatedCurrUsers,
          });
          // console.log(this.state.memberList);
        } else {
          this.setState({
            duplicateEmail: true,
          });
        }
        this.setState({
          email: "",
          name: "",
        });
      } else {
        // console.log("fail");
        this.setState({
          invalidEmail: true,
        });
      }
    } else {
      // console.log("toomany");
      this.setState({
        limitReached: true,
      });
    }
  }
  handleKeyPress(e) {
    if (e.key === "Enter") {
      customLog(this.state.currNumOfUsers);
      var emailAdded = e.target.value
        .toString()
        .toLowerCase()
        .replace(/ +/g, "");
      let emailValid = emailRegex.test(emailAdded) && emailAdded !== "";
      if (emailValid && this.state.currNumOfUsers < this.state.maxUsers) {
        e.target.value = "";
        e.preventDefault();

        const currentMemberList = this.state.memberList;
        let updatedCurrUsers = this.state.currNumOfUsers + 1;
        if (
          this.state.currNumOfUsers > this.state.maxUsers ||
          this.state.currNumOfUsers === this.state.maxUsers
        ) {
          this.promptNotification(
            localizationStrings.maxLimit,
            "error",
            "tc",
            5
          );

          this.setState({
            isDisabled: true,
          });
        } else if (this.state.currNumOfUsers < this.state.maxUsers) {
          this.setState({
            isDisabled: false,
          });
        }

        const idx = currentMemberList.findIndex(
          (member) => member.memberEmail === emailAdded
        );

        customLog(idx);
        const newMember = {
          memberEmail: emailAdded,
          isAdmin: false,
        };

        if (idx < 0) {
          //if not exist, idx = -1
          currentMemberList.push(newMember);

          this.setState({
            memberList: currentMemberList,
            isInvalid: false,
            isInvalidClose: false,
            invalidEmail: false,
            currNumOfUsers: updatedCurrUsers,
          });
          // console.log(this.state.memberList);
        }
      } else {
        e.target.value = "";
        this.setState({ invalidEmail: true });
      }
    } else if (
      this.state.currNumOfUsers > this.state.maxUsers ||
      this.state.currNumOfUsers === this.state.maxUsers
    ) {
      this.setState({
        isDisabled: true,
      });
    }
  }

  handleRowSelect = (row, isSelected) => {
    const { selectedMembers } = this.state;

    const updatedSelectedRows = isSelected
      ? [...selectedMembers, row.id]
      : selectedMembers.filter((id) => id !== row.id);

    this.setState({ selectedMembers: updatedSelectedRows });
  };

  handleSelectAll = (isSelected) => {
    const { memberList } = this.state;

    const updatedSelectedRows = isSelected
      ? memberList.map((row) => row.id)
      : [];

    this.setState({ selectedMembers: updatedSelectedRows });
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }
    const memberlist = this.state.memberList;
    //solve how to reload after edit
    const cellEditProp = {
      mode: "dbclick",
      blurToSave: true,
      //forceupdate must happen after aftersavecell
      afterSaveCell: () => {
        this.setState(
          {
            memberlist: this.state.memberList,
          },
          () => {
            this.forceUpdate();
          }
        );
        //this.forceUpdate();
      },
    };
    let anyerrors = this.state.memberList.some((member) => !member.noerrors);
    const sortedduplicateList = this.state.duplicateList;
    // .sort((a, b) => {
    //   const numA = parseInt(a.match(/\d+/)[0]);
    //   const numB = parseInt(b.match(/\d+/)[0]);
    //   return numA - numB;
    // });
    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />

        <button
          onClick={this.handleShow}
          className="loginsignupbutton"
          // style={{ position: "relative", bottom: "70px" }}
          style={{ padding: "5px 15px" }}
        >
          <strong>{localizationStrings.addMemberButtonTitle}</strong>
        </button>
        <a data-tip data-for="usernameTip">
          <span
            style={{ color: "#3C3E41", fontSize: "21px", marginLeft: "10px" }}
            className="glyphicon glyphicon-info-sign"
            aria-hidden="true"
          ></span>
        </a>
        <ReactTooltip id="usernameTip" effect="solid">
          <span>{localizationStrings.usernameTip}</span>
        </ReactTooltip>

        <Modal
          show={this.state.showPopup}
          onHide={this.handleClose}
          keyboard={false}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.addMemberTitle}</Modal.Title>
          </Modal.Header>

          {this.state.loading ? (
            <Modal.Body>
              <FadeLoader
                css={override}
                sizeUnit={"px"}
                size={125}
                color={"#a9a9a9"}
                onHide={this.handleClose}
                loading={this.state.loading}
              />
              <p>{localizationStrings.loadingMessage1}</p>
              <p>
                {localizationStrings.loadingMessage2pt1}
                <span style={{ color: "red" }}>
                  {localizationStrings.loadingMessage2pt2}
                </span>
                {localizationStrings.loadingMessage2pt3}
              </p>
              <p>{localizationStrings.loadingMessage3}</p>
            </Modal.Body>
          ) : (
            <Modal.Body>
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <p>
                    {localizationStrings.usedUpTitle}{" "}
                    <span
                      className={
                        this.state.currNumOfUsers >= this.state.maxUsers
                          ? "text-danger"
                          : this.state.maxUsers / 2 <= this.state.currNumOfUsers
                          ? "text-warning"
                          : "text-success"
                      }
                    >
                      {this.state.currNumOfUsers}
                    </span>
                    /{this.state.maxUsers}
                    {localizationStrings.memberLimitTitle}
                  </p>
                  {/* <button
                    onClick={this.handleReload}
                    style={{ border: "none" }}
                  >
                    <span
                      style={{
                        color: "#3C3E41",
                        fontSize: "16px",
                        border: "none",
                        cursor: "pointer"
                      }}
                      className="glyphicon glyphicon-refresh"
                      aria-hidden="true"
                    ></span>
                  </button> */}
                </div>

                <div style={{ marginBottom: 5 }}>
                  <Radio
                    inline
                    checked={this.state.radiocheck}
                    onClick={() => this.setState({ radiocheck: true })}
                  >
                    {localizationStrings.addLabel}
                  </Radio>
                  <Radio
                    inline
                    checked={!this.state.radiocheck}
                    onClick={() =>
                      this.setState({
                        radiocheck: false,
                        duplicateEmail: false,
                        limitReached: false,
                      })
                    }
                  >
                    {localizationStrings.importLabel}
                  </Radio>
                </div>
                {this.state.radiocheck ? (
                  <>
                    {/* <FormControl
                      onKeyPress={this.handleKeyPress}
                      placeholder={localizationStrings.emailPlaceholder}
                      aria-describedby="basic-addon1"
                      disabled={this.state.isDisabled}
                    /> */}
                    <div className={"flex"} style={{ marginTop: "25px" }}>
                      <FormControl
                        type="text"
                        placeholder={localizationStrings.emailPlaceholder}
                        style={{ margin: 3 }}
                        value={this.state.email}
                        onChange={(e) =>
                          this.setState({ email: e.target.value })
                        }
                      />
                      <FormControl
                        type="text"
                        placeholder={localizationStrings.namePlaceholder}
                        style={{ margin: 3 }}
                        value={this.state.name}
                        onChange={(e) =>
                          this.setState({ name: e.target.value })
                        }
                      />
                    </div>
                    {/* <br /> */}
                    <div>
                      <button
                        className="hoverRefreshBtn notifBtn"
                        style={{ margin: 3, width: 100, marginTop: "25px" }}
                        onClick={() =>
                          this.handleAdd(this.state.email, this.state.name)
                        }
                        // disabled={
                        //   this.state.currNumOfUsers >= this.state.maxUsers
                        // }
                      >
                        {localizationStrings.addLabel}
                      </button>
                      {/* <button
                      className="exportButton"
                        style={{ margin: 3 , width:50}}
                        onClick={() =>
                          this.handleAdd(this.state.email, this.state.name)
                        }
                        disabled={
                          this.state.currNumOfUsers >= this.state.maxUsers
                        }
                      >
                        Add
                      </button>
                      <Button
                      className="loginsignupbutton"
                        style={{ margin: 3 , width:50}}
                        onClick={() =>
                          this.handleAdd(this.state.email, this.state.name)
                        }
                        disabled={
                          this.state.currNumOfUsers >= this.state.maxUsers
                        }
                      >
                        Add
                      </Button>
                      <Button
                        style={{ margin: 3 , width:50}}
                        onClick={() =>
                          this.handleAdd(this.state.email, this.state.name)
                        }
                        disabled={
                          this.state.currNumOfUsers >= this.state.maxUsers
                        }
                      >
                        Add
                      </Button> */}
                    </div>
                    {this.state.invalidEmail && (
                      <span style={{ color: "red" }}>
                        {localizationStrings.emailAlert}
                      </span>
                    )}
                    {this.state.duplicateEmail && (
                      <span style={{ color: "red" }}>
                        {localizationStrings.duplicateEmailAlert}
                      </span>
                    )}
                    {this.state.limitReached && (
                      <span style={{ color: "red" }}>
                        {localizationStrings.limitReachedAlert}
                      </span>
                    )}
                  </>
                ) : (
                  <>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "25px",
                      }}
                    >
                      <input
                        type="file"
                        accept=".csv"
                        onChange={(event) => {
                          this.setState({
                            csvdata: event.target.files[0],
                          });
                          // console.log(this.state.csvdata);
                        }}
                      />
                      <p style={{ fontSize: "1em" }}>
                        {localizationStrings.CSVTemplateLabel}
                        <a
                          href="members-list.csv"
                          download="members-list.csv"
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                          }}
                        >
                          {localizationStrings.CSVTemplateLink}
                        </a>
                      </p>
                    </div>

                    <br />
                    <div>
                      <button
                        className="hoverRefreshBtn notifBtn"
                        style={{ width: 100, marginBottom: 10 }}
                        onClick={() => this.handlestring(this.state.csvdata)}
                        disabled={
                          this.state.csvdata == {} ||
                          this.state.csvdata == null ||
                          this.state.csvdata == undefined
                            ? true
                            : false
                        }
                      >
                        {localizationStrings.importLabel}
                      </button>
                    </div>
                    {this.state.invalidHeaders && (
                      <div>
                        <span style={{ color: "red" }}>
                          {localizationStrings.errorMessage1}
                        </span>
                      </div>
                    )}
                    {this.state.tooManyMems && (
                      <div>
                        <span style={{ color: "red" }}>
                          {localizationStrings.errorMessage2}
                        </span>
                      </div>
                    )}
                    {this.state.duplicates && (
                      <div>
                        <span style={{ color: "red" }}>
                          {localizationStrings.errorMessage3}
                        </span>
                        <div style={{ height: "10px" }} />
                        {sortedduplicateList.map((dupe, index) => (
                          <p style={{ color: "red", fontSize: "1em" }}>
                            {dupe}
                          </p>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
              <br />
              {/* <p>{anyerrors.toString()}</p>  */}
              {/* <button onClick={() => console.log(this.state.memberList)}>
                test
              </button> */}
              {/* make  email editable */}

              <BootstrapTable
                pagination
                deleteRow={true}
                selectRow={{
                  mode: "checkbox",
                  clickToSelect: true,
                  selected: this.state.selectedMembers,
                  onSelect: this.handleRowSelect,
                  onSelectAll: this.handleSelectAll,
                }}
                cellEdit={cellEditProp}
                data={this.state.memberList.sort((a, b) => {
                  // Compare 'noerrors' property of each member
                  if (a.noerrors === b.noerrors) {
                    return 0; // Maintain original order if 'noerrors' are the same
                  } else if (a.noerrors) {
                    return 1; // Move 'a' with errors to the end
                  } else {
                    return -1; // Move 'b' with errors to the end
                  }
                })}
                options={{
                  sizePerPage: 5,
                  pageStartIndex: 1,
                  hideSizePerPage: true,
                  afterDeleteRow: this.onAfterDeleteRow,
                  handleConfirmDeleteRow: this.customConfirmDialog,
                  deleteBtn: this.createCustomDeleteButton,
                  noDataText: localizationStrings.noDataTitle,
                }}
              >
                <TableHeaderColumn dataField="id" isKey={true} hidden={true} />

                <TableHeaderColumn
                  //isKey={true}
                  dataField="memberName"
                  dataFormat={this.handlenoname}
                  editable={true}
                >
                  {localizationStrings.memberNameLabel}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="memberEmail"
                  dataFormat={this.handleemailformat}
                  editable={true}
                >
                  {localizationStrings.memberEmailLabel}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="isAdmin"
                  dataFormat={this.renderBtn}
                  editable={false}
                >
                  {localizationStrings.isAdminLabel}
                  <a data-tip data-for="usernameTip2">
                    <span
                      style={{
                        color: "#3C3E41",
                        fontSize: "16px",
                        marginLeft: "10px",
                      }}
                      className="glyphicon glyphicon-info-sign"
                      aria-hidden="true"
                    ></span>
                  </a>
                  <ReactTooltip id="usernameTip2" effect="solid">
                    <span>{localizationStrings.usernameTip2}</span>
                  </ReactTooltip>
                </TableHeaderColumn>
              </BootstrapTable>
              <div className={"flex"}>
                <Button
                  style={{ width: "100%" }}
                  disabled={
                    this.state.isInvalid ||
                    anyerrors ||
                    this.state.memberList.length < 1
                  }
                  type="submit"
                  onClick={this.onSubmit}
                >
                  {localizationStrings.submitButton}
                </Button>
                <Button
                  onClick={this.handleClose}
                  disabled={this.state.isInvalidClose}
                >
                  {localizationStrings.closeButton}
                </Button>
              </div>
            </Modal.Body>
          )}

          {/* <Modal.Footer>
            <div className={"flex"}>
              <Button
                style={{ width: "100%" }}
                disabled={this.state.isInvalid}
                type="submit"
                onClick={this.onSubmit}
              >
                {localizationStrings.submitButton}
              </Button>
              <Button
                onClick={this.handleClose}
                disabled={this.state.isInvalidClose}
              >
                {localizationStrings.closeButton}
              </Button>
            </div>
          </Modal.Footer> */}
        </Modal>
      </div>
    );
  }
}

export default InviteMember;
